import styled from 'styled-components';

export const Container = styled.div`
    height: 50px;
    padding: 10px 10px 15px 10px;
    font-size: 14px;
    color: #FFFFFF;
    background-color: #3CD8A8;
    font-family: 'Poppins', sans-serif;
    border-radius: 5px;
    vertical-align: middle;
    align-items: center;
    margin: -10px 0px 10px 0px;

    svg{
        width: 30px;
        margin: 0px;
        margin-right: 10px;
        fill: #FFFFFF;
    }
`;
